/// <reference types="vite-plugin-svgr/client" />
import { useTranslation } from "react-i18next";
import EmptyCartPL from "@monorepo/assets/src/img/homePL.svg?react";
import { StyledPageWrapper, Title } from "@monorepo/components";

import { PageWrapper } from "components/Services/ServicesPage";

const GsmVouchers = () => {
  const { t } = useTranslation();
  return (
    <StyledPageWrapper>
      <PageWrapper>
        <Title>{t("services.gsm_top_up")}</Title>
        <EmptyCartPL />
      </PageWrapper>
    </StyledPageWrapper>
  );
};

export default GsmVouchers;
